import {useEffect, useState} from "react";
import {useLazyQuery} from "@apollo/client";
import moment from "moment";

import {MY_SHIFT_HISTORY} from "../queries/GraphQLQueries";
import {useRefresh} from "../contexts/RefreshContext";
import {buildMonthDateRangeIso} from "../helpers/DateTimeRangeHelper";

export default function useShiftHistory(selectedMonth, performerId) {
    const {refreshTrigger} = useRefresh();
    const [shifts, setShifts] = useState([]);
    const [performerActivitySummary, setPerformerActivitySummary] = useState({
        totalShiftCount: 0,
        totalShiftDurationInMinutes: 0,
        totalAmendmentCount: 0,
        netAmendmentMinutes: 0,
    });

    const [fetchShifts, {
        loading: isShiftHistoryLoading,
        error: shiftHistoryError,
        data: shiftHistoryData,
    }] = useLazyQuery(MY_SHIFT_HISTORY, {fetchPolicy: 'network-only'});

    const {startTime, endTime} = buildMonthDateRangeIso(selectedMonth);

    const monthEnd = moment(endTime);
    const now = moment();

    const effectiveEndTime = moment.min(monthEnd, now);

    useEffect(() => {
        if (!selectedMonth || !performerId) {
            return;
        }

        fetchShifts({
            variables: {
                performerId,
                startTime,
                endTime: effectiveEndTime.toISOString(),
                includeDeletedShifts: false,
                includeOnlyAccreditedServiceTypes: false,
            },
        });
    }, [selectedMonth, refreshTrigger, fetchShifts, performerId]);

    useEffect(() => {
        setShifts(shiftHistoryData?.me?.availability ?? []);

        setPerformerActivitySummary(
            shiftHistoryData?.performerActivityReport?.summary
            ?? {
                totalShiftCount: 0,
                totalShiftDurationInMinutes: 0,
                totalAmendmentCount: 0,
                netAmendmentMinutes: 0,
            }
        );
    }, [shiftHistoryData]);

    const amendments = shiftHistoryData?.me?.amendments ?? [];
    const canFetchShiftHistory = Boolean(selectedMonth && performerId);
    const hasResolvedShiftHistory = Boolean(shiftHistoryData || shiftHistoryError);
    const showProgress = isShiftHistoryLoading || (canFetchShiftHistory && !hasResolvedShiftHistory);


    return {shifts, amendments, performerActivitySummary, showProgress};
}